import { createAsyncThunk } from '@reduxjs/toolkit';

import { getDataApi } from '../../api/methods';

export const fetchInvoices = createAsyncThunk(
    'admin/invoices',
    (payload: any) => getDataApi({ path: 'admin/invoices', data: payload })
);
